"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimTokenInstructions = exports.getMultipleClaimStatusAccounts = exports.getClaimStatusAccount = exports.getClaimStatusKey = void 0;
const anchor_1 = require("@project-serum/anchor");
const spl_token_1 = require("@solana/spl-token");
const bs58 = __importStar(require("bs58"));
const helpers_1 = require("./util/helpers");
const gumdropIdl_1 = require("./util/gumdropIdl");
const GUMDROP_DISTRIBUTOR_ID = new anchor_1.web3.PublicKey('gdrpGjVffourzkdDRrQmySw4aTHr8a3xmQzzxSwFD1a');
/**
 * Get the claim status public key
 *
 * @param index - the index of the claim
 * @param distributor - the Gumdrop distributor public key
 * @param programId - the public key of the program to execute (Gumdrop program)
 * @returns [claim account public key, bump seed]
 */
const getClaimStatusKey = (index, distributor, programId = GUMDROP_DISTRIBUTOR_ID) => __awaiter(void 0, void 0, void 0, function* () {
    return yield anchor_1.web3.PublicKey.findProgramAddress([
        Buffer.from('ClaimStatus'),
        index.toArrayLike(Buffer, 'le', 8),
        distributor.toBuffer(),
    ], programId);
});
exports.getClaimStatusKey = getClaimStatusKey;
/**
 * Helper method to get the claim status account
 * If this does return a valid account, it means that the drop has been claimed already
 *
 * @param connection - the Solana connection object
 * @param index - the index of the claim
 * @param distributor - the Gumdrop distributor public key
 * @param programId - the public key of the program to execute (Gumdrop program)
 * @returns the claim status account or null if the drop has not been claimed
 */
const getClaimStatusAccount = (connection, index, distributor, programId = GUMDROP_DISTRIBUTOR_ID) => __awaiter(void 0, void 0, void 0, function* () {
    // Wallet not required to query accounts
    const provider = new anchor_1.AnchorProvider(connection, null, null);
    const program = new anchor_1.Program(gumdropIdl_1.gumDropIdl, programId, provider);
    const claimStatusResult = yield (0, exports.getClaimStatusKey)(index, distributor, programId);
    try {
        const account = yield program.account.claimStatus.fetch(claimStatusResult[0]);
        return account;
    }
    catch (e) {
        return null;
    }
});
exports.getClaimStatusAccount = getClaimStatusAccount;
/**
 * Helper method to get multiple claim status accounts
 *
 * @param connection - the Solana connection object
 * @param indexArray - the array of the indices of the claims
 * @param distributor - the Gumdrop distributor public key
 * @param programId - the public key of the program to execute (Gumdrop program)
 * @returns array the claim status accounts or null if the drop has not been claimed
 */
const getMultipleClaimStatusAccounts = (connection, indexArray, distributor, programId = GUMDROP_DISTRIBUTOR_ID) => __awaiter(void 0, void 0, void 0, function* () {
    // Wallet not required to query accounts
    const provider = new anchor_1.AnchorProvider(connection, null, null);
    const program = new anchor_1.Program(gumdropIdl_1.gumDropIdl, programId, provider);
    const claimStatusPromises = indexArray.map((it) => {
        return (0, exports.getClaimStatusKey)(it, distributor, programId);
    });
    const claimStatusKeys = (yield Promise.all(claimStatusPromises)).map((it) => it[0]);
    const accounts = yield program.account.claimStatus.fetchMultiple(claimStatusKeys);
    return accounts;
});
exports.getMultipleClaimStatusAccounts = getMultipleClaimStatusAccounts;
/**
 * Generate the instruction(s) to claim tokens from the Gumdrop distributor
 * This only works for a distributor configured to deal with fungible token
 * transfers to Solana wallets.
 *
 * @param params - the parameters for the instruction
 * @returns array of Solana transaction instructions
 */
const claimTokenInstructions = (params) => __awaiter(void 0, void 0, void 0, function* () {
    const { connection, claimUrl, playerPublicKey, programId } = params;
    // unpack the claim url
    const options = new URLSearchParams(claimUrl.split('?')[1]);
    const distributorKeyStr = options.get('distributor');
    const claimantKeyStr = options.get('handle');
    const claimAmountStr = options.get('amount');
    const claimantIndexStr = options.get('index');
    const proofStr = options.get('proof');
    const tokenAccStr = options.get('tokenAcc');
    if (!distributorKeyStr ||
        !claimantKeyStr ||
        !claimAmountStr ||
        !claimantIndexStr ||
        !proofStr ||
        !tokenAccStr) {
        throw new Error('Invalid claim');
    }
    // get the proof as a Buffer
    const proof = proofStr === ''
        ? []
        : proofStr.split(',').map((b) => {
            const ret = Buffer.from(bs58.decode(b));
            if (ret.length !== 32) {
                throw new Error('Invalid proof hash length');
            }
            return ret;
        });
    // get the distributor token and mint accounts
    const distributorKey = new anchor_1.web3.PublicKey(distributorKeyStr);
    const distributorTokenKey = new anchor_1.web3.PublicKey(tokenAccStr);
    const distTokenAccount = yield connection.getAccountInfo(distributorTokenKey);
    if (distTokenAccount === null) {
        throw new Error('Could not fetch distributor token account');
    }
    const tokenAccountInfo = spl_token_1.AccountLayout.decode(distTokenAccount.data);
    const distributorMintKey = new anchor_1.web3.PublicKey(tokenAccountInfo.mint);
    // get the claimant token account
    const claimantKey = new anchor_1.web3.PublicKey(claimantKeyStr);
    const claimantTokenKey = yield (0, helpers_1.getAssociatedTokenAddress)(claimantKey, distributorMintKey);
    const claimantTokenAccount = yield connection.getParsedTokenAccountsByOwner(claimantKey, {
        mint: distributorMintKey,
    });
    // get the claim account for this player (owned by the gumdrop program)
    const index = new anchor_1.BN(claimantIndexStr);
    const amount = new anchor_1.BN(claimAmountStr);
    const [claimStatusKey, nonce] = yield (0, exports.getClaimStatusKey)(index, distributorKey, programId);
    const provider = new anchor_1.AnchorProvider(connection, null, null);
    const program = new anchor_1.Program(gumdropIdl_1.gumDropIdl, programId, provider);
    const instructions = [];
    // if the claimant toke account does not exist, create it
    if (claimantTokenAccount.value.length === 0) {
        instructions.push(spl_token_1.Token.createAssociatedTokenAccountInstruction(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, distributorMintKey, claimantTokenKey, claimantKey, playerPublicKey));
    }
    instructions.push(program.instruction.claim(nonce /** the claim status account nonce */, index /** the index */, amount /** the amount */, playerPublicKey, proof /** proof */, {
        accounts: {
            distributor: distributorKey,
            claimStatus: claimStatusKey,
            from: distributorTokenKey,
            to: claimantTokenKey,
            temporal: playerPublicKey,
            payer: playerPublicKey,
            tokenProgram: spl_token_1.TOKEN_PROGRAM_ID,
            systemProgram: anchor_1.web3.SystemProgram.programId,
        },
    }));
    return instructions;
});
exports.claimTokenInstructions = claimTokenInstructions;
//# sourceMappingURL=gumdrop.js.map